<template>
  <div class="schools">
    <v-row v-if="current.user_level=='ADMIN'">
      <v-col class="d-flex justify-start">
        <v-btn class="ml-auto mr-3 green lighten-4" @click="dialog_add_school = !dialog_add_school">
          <v-icon left> mdi-plus </v-icon>
          {{ $t("manage.by_admin.schools.add_school_btn") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      dense 
      :locale="localeTranslate()"
      :headers="tableHeader()" 
      :items="api.schools" 
      item-key="id"
      :items-per-page="-1"
      :sort-by="[ 'school_id']"
      :sort-desc="[ false]"
      multi-sort
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip  top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="goTo(item.school_id)">
              <v-icon color="primary"> mdi-arrow-right </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("manage.by_admin.schools.go_btn") }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog_add_school" max-width="700px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog_add_school = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_admin.schools.add_school.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="newSchoolLabel('id')"
                  v-model="form.new_school_id"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="newSchoolLabel('eng_name')"
                  v-model="form.new_school_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="newSchoolLabel('chi_name')"
                  v-model="form.new_school_name_chi"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row align="center">
              <v-col cols="12">
                <v-checkbox
                  v-model="form.addInchargeAccount"
                  hide-details
                  :label="newSchoolLabel('incharge')"
                  class="shrink mr-2 mt-0"
                ></v-checkbox>
              </v-col>
              <v-expand-transition>
                <v-col v-show="form.addInchargeAccount" cols="12"  transition="slide-x-transition">
                  <v-col cols="12">
                    <v-text-field
                      dense
                      label="Username"
                      v-model="form.new_incharge_username"
                      :disabled="form.addInchargeAccount==false"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      dense
                      label="Password"
                      v-model="form.new_incharge_password"
                      :disabled="form.addInchargeAccount==false"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      dense
                      label="Email"
                      v-model="form.new_incharge_email"
                      :disabled="form.addInchargeAccount==false"
                    ></v-text-field>
                  </v-col>
                </v-col>
              </v-expand-transition>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="addNewSchool">
                {{ $t("manage.by_admin.schools.add_school.add_btn") }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { api_management } from "@/services/iot/api_management";
import { api_booking } from "@/services/iot/api_booking";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);
const apiBooking = new api_booking(process.env.VUE_APP_BASE_URL);
export default {
  name: "CreateBookSlot",
  data: function () {
    return {
      assignCheckbox: false,
      menu: false,
      dialog: false,
      dialog_add_school: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
      },
      api: {
        schools: [],
      },
      form: {
        addInchargeAccount: false,
        new_school_id: "",
        new_school_name: "",
        new_school_name_chi: "",
        new_incharge_username: "",
        new_incharge_password: "",
        new_incharge_email: "",
      },
      headers: [
        { text: 'School ID', value: 'school_id' },
        { text: 'School Name', value: 'school_name' },
        { text: 'School Chinese Name', value: 'school_chi_name' },
        { text: 'Create At', value: 'create_at' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headers_chi: [
        { text: 'ID', value: 'school_id' },
        { text: '英文全名', value: 'school_name' },
        { text: '中文全名', value: 'school_chi_name' },
        { text: '創建於', value: 'create_at' },
        { text: '操作', value: 'actions', sortable: false },
      ],
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.getSchoolList();
  },  
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    isValid: function(){
      var self = this;
      if(self.form.new_school_id.trim()==""){
        alert("Missing school ID");
        return false;
      }
      if(self.form.new_school_name.trim()==""){
        alert("Missing school name");
        return false;
      }
      if(self.form.new_school_name_chi.trim()==""){
        alert("Missing school chinese name");
        return false;
      }
      if(self.form.addInchargeAccount==true){
        if(self.form.new_incharge_username.trim()==""){
          alert("Missing incharge account username");
          return false;
        }
        if(self.form.new_incharge_password.trim()==""){
          alert("Missing incharge account password");
          return false;
        }
      }
      return true;
    },
    hexEncode(str){
      var hex, i;

      var result = "";
      for (i=0; i<str.length; i++) {
          hex = str.charCodeAt(i).toString(16);
          result += ("000"+hex).slice(-4);
      }
      return result
    },
    hexDecode(str){
      var j;
      var hexes = str.match(/.{1,4}/g) || [];
      var back = "";
      for(j = 0; j<hexes.length; j++) {
        back += String.fromCharCode(parseInt(hexes[j], 16));
      }
      return back;
    },
    addNewSchool(){
      var self = this;

      if(self.isValid()){
        apiManagement.addNewSchool(self.form.new_school_id, self.form.new_school_name, self.form.new_school_name_chi, self.current.username, self.current.auth_token)
        .then((response) =>{
          if(response.status=="success"){
            if(self.form.addInchargeAccount==true){
              self.addInchargeAccount();
            }
            else {
              self.$store.commit("showSnackBar", "New School has been added");
              self.dialog_add_school = !self.dialog_add_school;
              self.form.new_incharge_email = "";
              self.form.new_incharge_password = "";
              self.form.new_incharge_username = "";
              self.form.new_school_id = "";
              self.form.new_school_name = "";
              self.form.new_school_name_chi = "";
              self.addInchargeAccount = false;
              self.getSchoolList();
            }            
          }
          else if(response.status=="fail"){
            self.$store.commit("showSnackBar", response.message);
          }
        });
      }
    },
    newSchoolLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc'){
        if (label=='id'){
          return "學校ID"
        }
        else if (label=='eng_name'){
          return "英文全名"
        }
        else if (label=='chi_name'){
          return "中文全名"
        }
        else if (label=='incharge'){
          return "創立一個負責人級別帳號"
        }
      }
      else {
        if (label=='id'){
          return "School ID"
        }
        else if (label=='eng_name'){
          return "English Full Name"
        }
        else if (label=='chi_name'){
          return "Chinese Full Name"
        }
        else if (label=='incharge'){
          return "Create an incharge level account"
        }
      }
    },
    tableHeader(){
      var self = this;
      if(self.$i18n.locale=='tc')
        return self.headers_chi;
      else
        return self.headers;
    },
    addInchargeAccount(){
      var self = this;
      apiManagement.addInchargeAccount(self.form.new_school_id, self.form.new_incharge_username, self.form.new_incharge_password, self.form.new_incharge_email, self.current.username, self.current.auth_token)
      .then((response) =>{
        if(response.status=="success"){
          self.$store.commit("showSnackBar", "New School has been added");
          self.dialog_add_school = !self.dialog_add_school;
          self.form.new_incharge_email = "";
          self.form.new_incharge_password = "";
          self.form.new_incharge_username = "";
          self.form.new_school_id = "";
          self.form.new_school_name = "";
          self.form.new_school_name_chi = "";
          self.addInchargeAccount = false;
          self.getSchoolList();
        }
        else if(response.status=="fail"){
          self.$store.commit("showSnackBar", "New School has been added, while " + response.message);
        }
      });
    },
    getSchoolList(){
      var self = this;
      apiManagement.getSchoolList().then((response) => {
        self.api.schools = response.schools;
      });
    },
    closeDialog() {
      this.$emit("update-parent-dialog", false);
    },
    goTo(school_id){
      var self = this;
      self.$router.push("/management/school/"+school_id);
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>